type HousingPageDisplay =
  | 'guild_and_team_pages'
  | 'guild_page_only'
  | 'team_pages_only'
  | 'nowhere'

const housingPageDisplay = (guild?: wowaudit.Guild): HousingPageDisplay =>
  guild?.settings.housingPageDisplay.value as HousingPageDisplay

export const shouldDisplayGuildHousingPage = (guild?: wowaudit.Guild) =>
  ['guild_and_team_pages', 'guild_page_only'].includes(
    housingPageDisplay(guild),
  )

export const shouldDisplayTeamHousingPage = (guild?: wowaudit.Guild) =>
  ['guild_and_team_pages', 'team_pages_only'].includes(
    housingPageDisplay(guild),
  )
